import React from 'react';
import { PERMISSIONS } from 'constants/permissions';
import { LegalIcon } from 'components/common/icons';
import { Col, EditableInfoComponent, Row, Typography } from 'components';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { LegalEditeModal } from './edit';
import { useLegal } from './useLegal';
import { useSupplierFormationTypeQuery } from 'api';

const { Text } = Typography;
export const SupplierLegal = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const { data = [] } = useSupplierFormationTypeQuery();
  const { modalState, onModalStateChange, legal } = useLegal();
  return (
    <>
      <EditableInfoComponent
        title={'Legal'}
        editable={hasAccess(PERMISSIONS.suppliers.legal.write)}
        icon={<LegalIcon />}
        onEdite={onModalStateChange}
      />
      <Row gutter={[0, 4]}>
        <Col span={24}>
          <Row justify={'space-between'}>
            <Col>
              <Text type={'secondary'}>Legal Name</Text>
            </Col>
            <Col>
              <Text type={'secondary'}>{legal?.name || 'Not Set'}</Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify={'space-between'}>
            <Col>
              <Text type={'secondary'}>Formation Type</Text>
            </Col>
            <Col>
              <Text type={'secondary'}>
                {data.find((type: any) => type.value === legal?.formationType)?.label || 'Not Set'}
              </Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify={'space-between'}>
            <Col>
              <Text type={'secondary'}>Tax Number</Text>
            </Col>
            <Col>
              <Text type={'secondary'}>{legal?.taxNumber || 'Not Set'}</Text>
            </Col>
          </Row>
        </Col>
      </Row>
      <LegalEditeModal modalState={modalState} onModalStateChange={onModalStateChange} dataToEdit={legal} />
    </>
  );
});
